const fontSetStore = {
  state: {
    sizeFonts: 0
  },
  mutations: {
    SET_FONT_SIZE(state, size) {
      state.sizeFonts = size;
    }
  },
  actions: {
    setFontSize({ commit }, size) {
      commit('SET_FONT_SIZE', size);
    },
    changeFontSize({ state }, data) {
      const { size, lineHeight } = data;
      let result = {
        size,
        lineHeight
      };
      if (state.sizeFonts === 0.5) {
        result.size = 26;
        result.lineHeight = 29;
      } else if (state.sizeFonts === 1) {
        result.size = 32;
        result.lineHeight = 34;
      }
      return result;
    }
  }
};

export default fontSetStore;
